import React, { useEffect, useState } from 'react';
import './AboutPage.css';

const AboutPage = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const animatedElements = document.querySelectorAll('[data-animate]');
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -5% 0px'
      }
    );

    animatedElements.forEach(el => observer.observe(el));

    return () => {
      animatedElements.forEach(el => observer.unobserve(el));
      observer.disconnect();
    };
  }, []);

  return (
    <div className="about-page">
      {/* Header */}
      <header className="header">
        <a href="/" className="header-logo-link">
          <span className="header-logo-group">
            <img
              src="/assets/brand/WarmCore logo Eng black.svg"
              alt="WarmCore"
              className="header-logo header-logo-eng"
            />
            <img
              src="/assets/brand/WarmCore Title CHN black.svg"
              alt="暖芯科技"
              className="header-logo header-logo-chn"
            />
          </span>
        </a>
        <nav className="header-nav">
          <a href="/gmet-tech" className="nav-link">
            <span className="nav-link-bold gmet-trademark">GMET</span>®技术
          </a>
          <a href="/products" className="nav-link">解决方案与产品</a>
          <a href="/about" className="nav-link">关于我们</a>
        </nav>
        <button
          className="header-menu-button"
          type="button"
          aria-label="Toggle navigation menu"
          aria-expanded={isMobileMenuOpen}
          onClick={() => setIsMobileMenuOpen(prev => !prev)}
        >
          <span className={`header-menu-line ${isMobileMenuOpen ? 'is-open' : ''}`}></span>
          <span className={`header-menu-line ${isMobileMenuOpen ? 'is-open' : ''}`}></span>
          <span className={`header-menu-line ${isMobileMenuOpen ? 'is-open' : ''}`}></span>
        </button>
      </header>
      {isMobileMenuOpen && (
        <div className="header-mobile-menu">
          <a
            href="/gmet-tech"
            className="header-mobile-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <span className="nav-link-bold gmet-trademark">GMET</span>®技术
          </a>
          <a
            href="/products"
            className="header-mobile-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            解决方案与产品
          </a>
          <a
            href="/about"
            className="header-mobile-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            关于我们
          </a>
        </div>
      )}

      {/* About Section */}
      <section className="about-section">
        <div className="about-content-wrapper">
          <div className="about-text-content" data-animate="fade-up">
            <p className="about-description">
              北京暖芯科技有限公司是一家专注于新型电热材料研发、微气候调控，及相关产品生产的高新技术企业，拥有多项专利与行业认证资质。
            </p>
            <p className="about-description">
              我们以自主研发的GMET材料为基础，结合数字化控制、人工智能和人性化设计，重新定义微气候控制。通过对每一项细节的把控，为用户提供最安全、智能、舒适、节能的体验。
            </p>
            <p className="about-description about-description-last">
              我们的愿景，是让科技融入生活的每一个角落。
            </p>
            <button className="contact-button" data-animate="fade-up">
              联系我们
            </button>
          </div>

          <div className="about-visual-content">
            <img
              src="/assets/mag.png"
              alt="WarmCore map"
              className="china-map"
              data-animate="fade-left"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-divider"></div>
        
        <div className="footer-content">
          <div className="footer-newsletter">
            <div className="footer-brand-logos">
              <img
                src="/assets/brand/WarmCore logo Eng black.svg"
                alt="WarmCore"
                className="footer-brand-logo footer-brand-logo-eng"
              />
            </div>
            <div className="footer-newsletter-input">
              <p className="footer-newsletter-title">
                希望获取更多咨询？
                <br />
                留下您的邮箱
              </p>
              <div className="footer-newsletter-field">
                <span className="footer-newsletter-placeholder">输入电子邮件</span>
                <span className="footer-newsletter-underline" />
                <img
                  src="/assets/Arrow.svg"
                  alt=""
                  aria-hidden="true"
                  className="footer-email-arrow"
                />
              </div>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3 className="footer-column-title">关于公司</h3>
              <ul className="footer-column-links">
                <li><a href="/gmet-tech">技术创新</a></li>
                <li><a href="/about">关于我们</a></li>
                <li><a href="#contact">联系我们</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-column-title">服务支持</h3>
              <ul className="footer-column-links">
                <li><a href="#partnership">企业合作</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3 className="footer-column-title">产品</h3>
              <ul className="footer-column-links">
                <li><a href="/products">解决方案与产品</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-language-selector">
          <img 
            src="https://api.builder.io/api/v1/image/assets/TEMP/b5713774f00b3eb06583559e2886eddbd5835929?width=24" 
            alt="Language" 
            className="footer-language-icon"
          />
          <span className="footer-language-text">ENG</span>
          <img 
            src="https://api.builder.io/api/v1/image/assets/TEMP/cfc9047dc43436e605a5762b2ab61e04ed7c4aa9?width=16" 
            alt="Dropdown" 
            className="footer-language-arrow"
          />
        </div>

        <p className="footer-copyright">北京暖芯科技有限公司</p>
      </footer>
    </div>
  );
};

export default AboutPage;
